import { useMemo } from 'react';

import { NameAndCreateDateFormatter } from '@/components/Grid/components/Table/formatters';
import { defaultActionsColumn, defaultColumn, defaultColumnId, deleteAction, editAction } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Name', info => <NameAndCreateDateFormatter info={info} />),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
